import React, {useEffect} from 'react';
import "aos/dist/aos.css";
import AOS from "aos";
import '../style/movecleaning.css';
import "../style/officecleaning.css";
import { Typography } from "@mui/material";
import { FaRegCheckCircle } from "react-icons/fa";
import { LazyLoadImage } from "react-lazy-load-image-component";
import imgServ1 from "../images/photo-movecleaning.png";
import imgServ2 from "../images/photo-movecleaning2.png";
import imgServ3 from "../images/photo-movecleaning3.png";
import imgServ4 from "../images/photo-movecleaning4.png";
import Infokontakt from "../components/Infokontakt";
import Footer from "../components/Footer";

function Movecleaning() {
    useEffect(() => {
        AOS.init();
        window.scrollTo(0, 0);
      }, []);
    
      return (
        <div className="continer-office-cleaning">
          <div className="cover-img-content-movecleaning">
            <div className="photocontent-box">
              <Typography
                variant="h3"
                sx={{
                  color: "var(--mainColor)",
                  fontFamily: "var(--fontFamily)",
                  fontWeight: "medium",
                }}
              >
                Umzugsreinigung
              </Typography>
            </div>
          </div>
          <div className="content-text-for-services">
            <div className="text-service-first">
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  color: "var(--mainColorLight)",
                  fontFamily: 'var(--fontFamily)',
        fontWeight: '700',
                }}
              >
                Willkommen zu unserem Umzugsreinigung!
              </Typography>
            </div>
            <div
              className="text-body-service"
              data-aos="zoom-out"
              data-aos-anchor-placement="top-bottom"
              data-aos-offset="100"
              data-aos-duration="1000"
              data-aos-once="true"
            >
              <Typography
                gutterBottom
                variant="body2"
                sx={{
                  fontWeight: "normal",
                  fontFamily: 'var(--fontFamily)',
                   color:'var(--textColor)'
                }}
              >
              Beim Umzug gibt es genug zu tun. Überlassen Sie uns die Reinigung, damit Sie sich auf den reibungslosen Ablauf Ihres Umzugs konzentrieren können.  Unsere Glasreinigungsservice bietet professionelle Reinigungslösungen für alle Arten von Glasflächen, sei es in Wohnhäusern, Bürogebäuden, Geschäften oder anderen gewerblichen Einrichtungen. Wir verstehen, dass saubere und glänzende Glasoberflächen nicht nur für eine ästhetisch ansprechende Umgebung wichtig sind, sondern auch für die Wartung und den Werterhalt Ihrer Immobilie.
                <br /> Unsere Umzugsreinigungsdienste bieten Ihnen eine gründliche und professionelle Reinigung Ihres alten oder neuen Zuhauses, um Ihnen den stressfreien Umzug zu ermöglichen. Wir kümmern uns um die gründliche Reinigung aller Bereiche, einschließlich Böden, Oberflächen, Küche, Badezimmer und mehr. Verlassen Sie sich auf uns, um Ihr Zuhause makellos sauber und bereit für den Umzug zu hinterlassen.
                <br />Unser Team von erfahrenen Reinigungsfachkräften verwendet hochwertige Reinigungsmittel und moderne Ausrüstung, um sicherzustellen, dass selbst die hartnäckigsten Verschmutzungen entfernt werden. Wir verstehen die Bedeutung eines sauberen und ordentlichen Zuhauses während des Umzugs und sind bestrebt, Ihnen dabei zu helfen, einen reibungslosen Übergang zu gewährleisten. Kontaktieren Sie uns noch heute, um Ihre Umzugsreinigung zu planen und sich um eine Sorge weniger zu kümmern!
              </Typography>
            </div>
            <div className="textandphoto-service">
              <div
                className="text-service-line"
                data-aos="fade-right"
                data-aos-offset="50"
                data-aos-duration="1000"
              >
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Fachkundige und zuverlässige Reinigungsteams
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
               
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                Verwendung umweltfreundlicher Reinigungsmittel
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                   color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Maßgeschneiderte Reinigungslösungen, die Ihren Bedürfnissen entsprechen
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Pünktlichkeit und Effizienz bei der Arb
                </Typography>
                
                
               
              </div>
              <div className="photo-service-line">
                <div
                  className="photo1-service"
                  data-aos="flip-left"
                  data-aos-offset="50"
                  data-aos-duration="1000"
                >
                  <LazyLoadImage
                    src={imgServ1}
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}
                  />
                </div>
                <div
                  className="photo2-service"
                  data-aos="flip-right"
                  data-aos-offset="50"
                  data-aos-duration="1000"
                >
                  <LazyLoadImage
                    src={imgServ2}
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="content-text-for-services2">
            <div className="text-service-first">
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  color: "var(--mainColorLight)",
                  fontFamily: 'var(--fontFamily)',
                  fontWeight: '700',
                }}
              >
                Entdecken Sie die Vorteile unserer Umzugsreinigung!
              </Typography>
            </div>
            <div className="text-body-service2">
              <div
                className="text-for-service-body"
                data-aos="fade-right"
                data-aos-anchor-placement="top-bottom"
                data-aos-offest="200"
                data-aos-duration="1000"
              >
                <Typography gutterBottom variant="body2" sx={{
                   fontFamily: 'var(--fontFamily)',
                   color:'var(--textColor)'
                }}>
                  
                  Unser Engagement für Qualität erstreckt sich auf alle unsere Dienstleistungen, einschließlich unserer hoch bewerteten Reinigungsdienste. Egal, ob Sie eine gründliche Bauabschlussreinigung für Ihr Wohnhaus, Ihr Bürogebäude oder Ihre gewerbliche Einrichtung benötigen, wir sind für Sie da. Unsere Bauabschlussreinigungsdienste zielen darauf ab, Ihre Baustelle in bestem Zustand zu übergeben, sei es nach Renovierungen, Neubauten oder Umbauten.
                <br />Wir verstehen die Bedeutung einer gründlichen und professionellen Bauabschlussreinigung, um sicherzustellen, dass Ihre Immobilie den höchsten Standards entspricht. Unser erfahrenes Reinigungsteam verwendet moderne Techniken und hochwertige Reinigungsmittel, um Baureste, Schmutz und Staub zu beseitigen. Wir kümmern uns um alle Bereiche Ihrer Baustelle, von Böden über Oberflächen bis hin zu Glasflächen.


                </Typography>
              </div>
            </div>
            <div className="textandphoto-service2">
              <div
                className="text-service-line2"
                data-aos="fade-right"
                data-aos-offset="300"
                data-aos-duration="1000"
              >
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Professionelle Reinigung für alle Arten von Umzugsreinigung
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                 
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Gründliche Entfernung von Schmutz, Staub und Rückständen
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                Streifenfreie und glänzende Ergebnisse
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Pünktliche und zuverlässige Dienstleistungen
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Wettbewerbsfähige Preise und transparente Abrechnung
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Hochbewertete Reinigung.
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Umzugsreinigung in der Nähe von Städten
                </Typography>
              </div>
              <div className="photo-service-line2">
                <div
                  className="photo3-service"
                  data-aos="flip-left"
                  data-aos-offset="200"
                  data-aos-duration="1000"
                >
                  <LazyLoadImage
                    src={imgServ4}
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}
                  />
                </div>
                <div
                  className="photo4-service"
                  data-aos="flip-right"
                  data-aos-offset="200"
                  data-aos-duration="1000"
                >
                  <LazyLoadImage
                    src={imgServ3}
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
    
          <Infokontakt />
          <Footer />
        </div>
      );
}

export default Movecleaning
